import { observer } from 'mobx-react';
import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../models/forms/IForm';
import { CloseModalIcon } from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import AddEditProductManagementForm from '../forms/add-edit-product-mgmt-form';

const AddEditProductManagement = (props: IFormModalProps) => {
  const {
    factoryStore,
    productStore,
    processTemplateStore,
    processStore,
    teplarPrintStore,
    kishuMarkStore,
  } = useStore();
  const { resetGetFactoryDetail } = factoryStore;
  const {
    AddProductService,
    UpdateProductService,
    productState,
    GetProductByIdService,
    addUpdateProductState,
    productDetails,
    addProductFileState,
    deleteProductFileState,
    resetProductImages,
    resetAddUpdateProductState,
    ValidateProductNameService,
    isProductNameValid,
    DeleteProductFileService,
    getNewAccidentalDeletedFiles,
    resetNewAccidentalDeletedFiles,
    resetDeleteProductFileState,
  } = productStore;

  const {
    teplarDetailsList,
    resetTeplarDetail,
    csvUploadState,
    resetCsvUploadState,
    getTeplarByIdState,
    resetGetTeplarByIdState,
  } = teplarPrintStore;

  const {
    resetProcessTemplateDetail,
    processTemplateState,
    getAllTemplateState,
  } = processTemplateStore;

  const { resetProcessDetail, processState } = processStore;
  const [closeModal, setCloseModal] = useState(true);
  const {
    getKishuMarkByKishuNameState: getKishuMarkByKishuState,
    resetGetKishuMarkByKishuNameState,
  } = kishuMarkStore;

  const validateProductNameHandler = (id: string) => {
    ValidateProductNameService(Number(getTenantIdFromLocalStorage()), id);
  };
  const onSubmitForm = (values: any) => {
    if (props.id < 0) {
      AddProductService(values);
    } else {
      UpdateProductService({ ...values, Id: props.id });
    }
    resetProcessTemplateDetail();
  };

  const onModalClosed = () => {
    resetGetFactoryDetail();
    props.modalClosed();
    resetProductImages();
    resetProcessDetail();
    resetTeplarDetail();
    resetCsvUploadState();
    resetGetTeplarByIdState();
    resetGetKishuMarkByKishuNameState();
    localStorage.removeItem('selectedProcesses');
    resetNewAccidentalDeletedFiles();
    setCloseModal(true);
  };

  const modalHandler = (isModalClose: boolean = false) => {
    setCloseModal(false);
    resetGetFactoryDetail();
    resetProductImages();
    resetProcessDetail();
    resetTeplarDetail();
    resetCsvUploadState();
    resetGetTeplarByIdState();
    resetGetKishuMarkByKishuNameState();
    localStorage.removeItem('selectedProcesses');
    resetNewAccidentalDeletedFiles();
    localStorage.setItem('images', JSON.stringify([]));
  };

  useEffect(() => {
    if (props.id > 0) {
      GetProductByIdService(Number(getTenantIdFromLocalStorage()), props.id);
    }
  }, []);

  const cleanedInitialValues = useMemo(() => {
    if (!productDetails || Object.keys(productDetails).length === 0)
      return productDetails;

    // console.log('Cleaned Initial Values FileIds:', (productDetails.Process || []).map((p: any) => ({
    //   ProcessName: p.ProcessName,
    //   FileIds: (p.fileIndices || []).flatMap((fi: any) => (fi.FileDetail || []).map((fd: any) => fd.FileId))
    // })));

    return {
      ...productDetails,
      Process: (productDetails.Process || []).map((proc: any) => ({
        ...proc,
        fileIndices: (proc.fileIndices || []).map((file: any) => ({
          ...file,
          CheckItems: (file.CheckItems || []).filter((item: any) => {
            if (item.CheckMessage && (item.CheckMessage || '').trim() !== '') {
              return true;
            }
            const nestedItems = item.CheckItems || item.CheckItemMessage;
            if (
              nestedItems &&
              Array.isArray(nestedItems) &&
              nestedItems.length > 0
            ) {
              return true;
            }
            return false;
          }),
        })),
      })),
      activeIndex: 1,
    };
  }, [productDetails]);

  useEffect(() => {
    if (addUpdateProductState.success) {
      if (props.id < 0) {
        toast.success(formatMessage('added_success'));
        if (closeModal) {
          onModalClosed();
        } else {
          modalHandler();
        }
      } else {
        toast.success(formatMessage('updated_success'));
        onModalClosed();
      }
    }
    resetDeleteProductFileState();
  }, [addUpdateProductState.success]);

  useEffect(() => {
    if (addUpdateProductState.error) {
      toast.error(formatMessage(addUpdateProductState.error));
      resetAddUpdateProductState();
    }
  }, [addUpdateProductState.error]);
  return (
    <React.Fragment>
      <Modal
        className="product-template"
        size="xl"
        show={true}
        centered={true}
        onHide={() => { }}
      >
        <Modal.Header>
          <Modal.Title>
            {props.id < 0 ? (
              <FormattedMessage id="add_product" />
            ) : (
              <FormattedMessage id="update_product" />
            )}
          </Modal.Title>
          <button
            onClick={() => {
              if (getNewAccidentalDeletedFiles?.length > 0) {
                DeleteProductFileService(
                  Number(getTenantIdFromLocalStorage()),
                  Number(props.id || 0),
                  getNewAccidentalDeletedFiles,
                  []
                ).then(() => {
                  resetNewAccidentalDeletedFiles();
                });
              }
              onModalClosed();
            }}
            data-testid="Close"
            className="Crossicons"
          >
            <CloseModalIcon />
          </button>
        </Modal.Header>
        <div>
          <AddEditProductManagementForm
            id={props.id}
            initialValues={cleanedInitialValues}
            isLoading={
              addUpdateProductState.inProgress ||
              productState.inProgress ||
              addProductFileState.inProgress ||
              deleteProductFileState.inProgress ||
              csvUploadState.inProgress ||
              getTeplarByIdState.inProgress ||
              processTemplateState.inProgress ||
              processState.inProgress ||
              getKishuMarkByKishuState.inProgress ||
              getAllTemplateState.inProgress
            }
            onModalClosed={onModalClosed}
            onSaveAndNextClick={modalHandler}
            submitHandler={onSubmitForm}
            // teplarDetailsList={teplarDetailsList}
            validateProductName={validateProductNameHandler}
            isProductNameValid={isProductNameValid}
            setCloseModal={setCloseModal}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default observer(AddEditProductManagement);
